<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="fai_code,pr_detail,pr_code"
      placeholder="输入单据编号、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/qc/firstqc/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.fai_code}}</p>
          <p class="list-item-muted">{{item.pr_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_detail}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.fai_status!='已审核'}"
          >{{item.fai_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/firstqc/list",
      filters: [
        {
          type: "date",
          name: "fai_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "fai_status = '未审核'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "fai_status = '已审核'"
            },
          ]
        }
      ]
    };
  }
};
</script>